const signatureSources = Object.freeze({
	registration: 1,
	postRegistration: 2,
	pei: 3,
  initialEligibilityDetermination: 4,
});
    
export const SignatureSources = signatureSources;